import GenericRequest, { METHOD_GET } from '../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../shared/webservices/endpoint';

export default class DocumentStatesRequest extends GenericRequest {

    constructor() {
        super(METHOD_GET, ApiEndpoints.DOCUMENT_STATES);
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/states/DocumentStatesRequest.js